import API from "@/models/API";

export default class GiftCategories {
    constructor(item = {}) {
        this.gift_id = item.gift_id || null;
        this.supplier_store_id = item.supplier_store_id || null;
        this.gift_category_id = item.gift_category_id || null;
        this.gift_type_id = item.gift_type_id || null;
        this.title = item.title || "";
        this.description = item.description || "";
        this.points = item.points || null;
        this.printed_catalog_code = item.printed_catalog_code || "";
        this.product_code = item.product_code || "";
        this.show_on_catalog = item.show_on_catalog || false;
        this.cost = item.cost || "";
        this.redeem_company_ids = [];
        this.redeem_stores = item.redeem_stores || []
    }

    static get = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/gifts`);

    static getCategories = (query) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/gift-categories${query}`
        );

    static getGift = id =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/gifts/${id}`
        );

    static getGiftTypes = () =>
        API.get(
            `/common/gift-types`
        );

    static getSuppliers = () =>
        API.get(
            `/common/companies/${localStorage.getItem("storeId")}/suppliers`
        );

    static create = body =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/gift-categories`,
            body
        );

    static update = (id, body) =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/gift-categories/${id}`,
            body
        );

    static delete = id =>
        API.delete(
            `/companies/${localStorage.getItem("storeId")}/gift-categories/${id}`
        );

    static uploadImage = (id, image) =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/gift-categories/${id}/images`,
            image
        );
}
